import React from 'react'
import SvgIcon from 'rambler-ui/icons/SvgIcon'

export default function LentaLogo ({width, height}) {
  return (
    <SvgIcon
      color='currentColor'
      style={{
        width: width,
        height: height
      }}
      viewBox='0 0 117 50'>
      <path
        fill='#000'
        fillRule='evenodd'
        d='M94.54 29.408c-1.864 0-2.92-1.263-2.92-4.066v-6.715h-2.835v6.105c0 4.258 1.557 6.935 5.756 6.935 4.195 0 5.745-2.735 5.745-6.934v-6.108h-2.837v6.717c0 2.8-1.103 4.065-2.908 4.065l-.002.001zm-14.555-8.526h1.074c2.03 0 3.042 1.003 3.042 2.73 0 1.528-1.056 2.55-3.062 2.55h-1.054v-5.28zm-2.837 10.486h2.837v-2.951h.859c.387 0 1.253-.02 1.594-.079l2.614 3.03h3.345l-3.423-4.033c1.253-.917 1.967-2.16 1.967-3.723 0-3.217-2.11-4.985-5.62-4.985h-4.173v12.741zm-4.772-1.238c0 .848.712 1.537 1.588 1.537a1.553 1.553 0 0 0 1.563-1.537 1.536 1.536 0 0 0-1.553-1.518h-.01c-.876 0-1.588.666-1.588 1.516v.002zm-8.105-6.875l1.906 3.842H62.45l1.821-3.842zm4.037 8.113h3.042l-7.015-13.035h-.122l-6.808 13.035h3.036l.999-2.116h5.813l1.055 2.116zm-23.05-12.741v7.45l-8.776-7.744h-.125V31.37h2.836V24.2l8.782 7.467h.117V20.882h4.635V31.37h2.838V20.882h4.357v-2.255H45.257zm-15.064 13.04c2.19 0 3.67-.299 4.642-.942v-2.633c-.692.711-2.29 1.316-4.07 1.316-1.434 0-3.243-.431-3.243-1.701 0-1.942 1.924-2.019 4.445-2.019h.339v-2.075h-.463c-2.495 0-3.722-.176-3.722-1.516 0-1.15.97-1.507 2.251-1.507 1.673 0 2.402.348 3.106.827v-2.512c-.687-.313-1.588-.572-3.106-.572-2.838 0-5.086 1.062-5.086 3.647 0 1.05.715 2.413 1.909 2.627-1.605.255-2.552 1.65-2.552 3.1 0 2.9 2.49 3.96 5.55 3.96zm-13.48-.299V18.627h2.84v10.295h4.563v2.448h-7.403v-.002zM0 0v50V0zm117 0v50V0z'
      />
    </SvgIcon>
  )
}
